import React from "react";
import { Link } from "react-router-dom";
import "./Landing.css";

const Landing = () => {
  return (
    <div className="landing">
       

      {/* Hero Section */}
      <section className="hero">
        <h1>Build Your Portfolio in Minutes 🚀</h1>
        <p>No coding required. Showcase your skills, projects, and achievements with ease.</p>
        <Link to="/dashboard" className="btn primary">Start For Free</Link>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose Us?</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <h3>🚀 Quick Setup</h3>
            <p>Create a professional portfolio in just a few clicks.</p>
          </div>
          <div className="feature-card">
            <h3>✨ AI Assistance</h3>
            <p>Let AI generate headlines & summaries for your portfolio.</p>
          </div>
          <div className="feature-card">
            <h3>🎨 Full Customization</h3>
            <p>Choose themes, colors, and layouts that suit your brand.</p>
          </div>
        </div>
      </section>

      {/* Featured Portfolios */}
      <section className="showcase">
        <h2>Discover Inspiring Portfolios</h2>
        <p className="sub-text">
          Explore a diverse collection of portfolios crafted by talented professionals. 
          Get inspired and connect with creators.
        </p>

        <div className="portfolio-cards">
          <div className="portfolio-card">
            <div className="profile-pic">
              <img src="https://i.pravatar.cc/150?img=11" alt="profile" />
            </div>
            <h3>Yash</h3>
            <p className="role">Frontend Developer</p>
            <p className="desc">
              Passionate about crafting intuitive and visually appealing web apps.
            </p>
            <a href="/portfolio/yash" className="btn primary">Visit Portfolio ✨</a>
          </div>

          <div className="portfolio-card">
            <div className="profile-pic">
              <img src="https://i.pravatar.cc/150?img=12" alt="profile" />
            </div>
            <h3>Aasu Yadav</h3>
            <p className="role">Full Stack Developer</p>
            <p className="desc">
              Skilled in building scalable and dynamic applications.
            </p>
            <a href="/portfolio/aasu" className="btn primary">Visit Portfolio ✨</a>
          </div>

          <div className="portfolio-card">
            <div className="profile-pic">
              <img src="https://i.pravatar.cc/150?img=13" alt="profile" />
            </div>
            <h3>Ronak Sarvaya</h3>
            <p className="role">Developer</p>
            <p className="desc">
              Bringing creativity and innovation to unique projects.
            </p>
            <a href="/portfolio/ronak" className="btn primary">Visit Portfolio ✨</a>
          </div>

          <div className="portfolio-card">
            <div className="profile-pic">
              <img src="https://i.pravatar.cc/150?img=14" alt="profile" />
            </div>
            <h3>Utkarsh</h3>
            <p className="role">Full Stack Developer</p>
            <p className="desc">
              Deep understanding of modern web technologies & systems.
            </p>
            <a href="/portfolio/utkarsh" className="btn primary">Visit Portfolio ✨</a>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <h2>Ready to Build Your Portfolio?</h2>
        <p>Join thousands of professionals who trust us.</p>
        <Link to="/dashboard" className="btn secondary">Start For Free</Link>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© 2025 PortfolioBuilder. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Landing;
